export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker-legacy.708b0a00.worker.js");
}
